import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
export default class PollsIndexSidebar extends IndexSidebar {
  items() {
    const items = new ItemList();
    const canStartPoll = app.forum.attribute('canStartGlobalPolls');
    if (app.current.get('routeName') !== 'fof.polls.composer') {
      items.add('newGlobalPoll', m(Button, {
        icon: "fas fa-edit",
        className: "Button Button--primary App-primaryControl PollsPage-newPoll",
        itemClassName: "App-primaryControl",
        onclick: () => this.newPollAction(),
        disabled: !canStartPoll
      }, app.translator.trans("fof-polls.forum.poll.".concat(canStartPoll ? 'start_poll_button' : 'cannot_start_poll_button'))));
    }
    items.add('nav', m(SelectDropdown, {
      buttonClassName: "Button",
      className: "App-titleControl",
      accessibleToggleLabel: app.translator.trans('core.forum.index.toggle_sidenav_dropdown_accessible_label')
    }, this.navItems().toArray()));
    return items;
  }
  newPollAction() {
    if (!app.session.user) {
      app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
      return;
    }
    m.route.set(app.route('fof.polls.composer'));
  }
}
flarum.reg.add('fof-polls', 'forum/components/PollsIndexSidebar', PollsIndexSidebar);